import React, { useEffect, useState } from 'react';
import { Table } from '@naf/table';
import { useWindowResize } from '@hooks/Window/useWindowResize';
import { TableSerializerProps } from './Table.types';
import * as S from './Table.styles';

const COLLAPSED_ROW_LIMIT = 10;

/** The CMS writes `check` where a cell should render a tick. */
const CellContent = (cell: string) => {
  if (cell === 'check') {
    return <S.StyledCheckCircle size={24} />;
  }
  return cell;
};

export const NafCenterTableView = ({ value: { table, shouldCollapse, caption } }: TableSerializerProps) => {
  const [bodyWidth, setBodyWidth] = useState<number>();
  const [shouldRowsCollapse, setShouldRowsCollapse] = useState<boolean>(shouldCollapse);

  // Escapes its grid column by measuring <main>, hence the resize listener.
  const setWidth = () => {
    if (document) {
      const element = document.querySelector('main');
      if (element) {
        setBodyWidth(element.offsetWidth);
      }
    }
  };

  useEffect(() => {
    setWidth();
  }, []);

  useWindowResize(setWidth);

  return (
    <S.TableWrapper width={bodyWidth}>
      <h2>{caption}</h2>
      <Table>
        {table.rows.map((row, index) => (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {index <= COLLAPSED_ROW_LIMIT && (
              <S.Tr index={index}>
                {row.cells.map((cell) => (index === 0 ? <S.Th>{cell}</S.Th> : <S.Td>{CellContent(cell) || ''}</S.Td>))}
              </S.Tr>
            )}
          </>
        ))}
      </Table>
      <S.ShowMoreWrapper $isHidden={shouldRowsCollapse}>
        <S.StyledTable>
          {table.rows.map((row, index) => (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              {index > COLLAPSED_ROW_LIMIT && (
                <S.Tr>
                  {row.cells.map((cell) => (
                    <S.Td>{CellContent(cell) || ''}</S.Td>
                  ))}
                </S.Tr>
              )}
            </>
          ))}
        </S.StyledTable>
      </S.ShowMoreWrapper>
      {shouldRowsCollapse && table.rows.length > COLLAPSED_ROW_LIMIT + 1 && (
        <S.StyledButtonLink text="Se alle testpunker +" onClick={() => setShouldRowsCollapse(false)} />
      )}
    </S.TableWrapper>
  );
};
